<template>
  <div class="home-layout">
    <zhengzhou v-if="$GLOBAL_CONFIG.imageDirName === 'zhengzhou'"></zhengzhou>
    <guangdong
      v-else-if="$GLOBAL_CONFIG.imageDirName === 'guangdong'"
    ></guangdong>
    <zhengzhou v-else></zhengzhou>
  </div>
</template>

<script>
import zhengzhou from "./zhengzhouTemp";
import guangdong from "./gdHome";
export default {
  components: {
    zhengzhou,
    guangdong
  }
};
</script>
<style lang="scss" scoped>
.home-layout {
  width: 100%;
  height: 100%;
}
</style>
